var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMedio(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 584,
    height: 607,
    viewBox: "0 0 584 607",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M452.615 152.592L231.445 24.8984L117 90.9735L338.172 218.667L452.615 152.592Z",
    fill: "#003EB3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M338.211 468.792L117.039 341.099V100.719L338.211 228.412V468.792Z",
    fill: "#B6CEFB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M141.967 139.225L124.664 129.235V117.484L141.967 127.474V139.225Z",
    fill: "#F7F8FB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M182.162 162.432L176.898 159.393V147.641L182.162 150.68V162.432Z",
    fill: "#F7F8FB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M190.122 167.029L184.859 163.99V152.238L190.122 155.278V167.029Z",
    fill: "#F7F8FB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M198.084 171.626L192.82 168.587V156.836L198.084 159.875V171.626Z",
    fill: "#F7F8FB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M206.046 176.223L200.781 173.185V161.434L206.046 164.472V176.223Z",
    fill: "#F7F8FB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M149.719 143.697L167.02 153.687V141.934L149.719 131.945V143.697Z",
    fill: "#F7F8FB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M167.017 159.586L124.664 135.132V129.234L167.017 153.688V159.586Z",
    fill: "#5C93F8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M313.281 238.133L330.585 248.123V236.372L313.281 226.383V238.133Z",
    fill: "#F7F8FB"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M273.086 214.927L278.349 217.966V206.214L273.086 203.176V214.927Z",
    fill: "#F7F8FB"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M265.125 210.334L270.388 213.372V201.62L265.125 198.582V210.334Z",
    fill: "#F7F8FB"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M257.164 205.736L262.427 208.774V197.023L257.164 193.984V205.736Z",
    fill: "#F7F8FB"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M249.203 201.138L254.466 204.177V192.425L249.203 189.387V201.138Z",
    fill: "#F7F8FB"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M305.537 233.663L288.234 223.673V211.922L305.537 221.912V233.663Z",
    fill: "#F7F8FB"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M288.234 229.57L330.588 254.022V248.124L288.234 223.672V229.57Z",
    fill: "#5C93F8"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M238.695 195.074L216.547 182.287V170.535L238.695 183.323V195.074Z",
    fill: "#F7F8FB"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M141.967 171.499L124.664 161.509V149.758L141.967 159.747V171.499Z",
    fill: "#F7F8FB"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M182.162 194.704L176.898 191.664V179.914L182.162 182.952V194.704Z",
    fill: "#F7F8FB"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M190.122 199.303L184.859 196.263V184.512L190.122 187.551V199.303Z",
    fill: "#F7F8FB"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M198.084 203.9L192.82 200.861V189.109L198.084 192.148V203.9Z",
    fill: "#F7F8FB"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M206.046 208.494L200.781 205.455V193.703L206.046 196.741V208.494Z",
    fill: "#F7F8FB"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M149.719 175.97L167.02 185.96V174.209L149.719 164.219V175.97Z",
    fill: "#F7F8FB"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M167.017 191.858L124.664 167.404V161.508L167.017 185.96V191.858Z",
    fill: "#5C93F8"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M313.281 270.409L330.585 280.398V268.646L313.281 258.656V270.409Z",
    fill: "#F7F8FB"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M273.086 247.201L278.349 250.239V238.489L273.086 235.449V247.201Z",
    fill: "#F7F8FB"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M265.125 242.607L270.388 245.646V233.895L265.125 230.855V242.607Z",
    fill: "#F7F8FB"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M257.164 238.011L262.427 241.049V229.297L257.164 226.258V238.011Z",
    fill: "#F7F8FB"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M249.203 233.412L254.466 236.45V224.698L249.203 221.66V233.412Z",
    fill: "#F7F8FB"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M305.537 265.937L288.234 255.947V244.195L305.537 254.185V265.937Z",
    fill: "#F7F8FB"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M288.234 261.843L330.588 286.296V280.398L288.234 255.945V261.843Z",
    fill: "#5C93F8"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M238.695 227.348L216.547 214.561V202.809L238.695 215.595V227.348Z",
    fill: "#F7F8FB"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M141.967 203.769L124.664 193.779V182.027L141.967 192.017V203.769Z",
    fill: "#F7F8FB"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M182.162 226.973L176.898 223.935V212.184L182.162 215.222V226.973Z",
    fill: "#F7F8FB"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M190.122 231.571L184.859 228.533V216.781L190.122 219.82V231.571Z",
    fill: "#F7F8FB"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M198.084 236.17L192.82 233.132V221.379L198.084 224.418V236.17Z",
    fill: "#F7F8FB"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M206.046 240.762L200.781 237.724V225.973L206.046 229.011V240.762Z",
    fill: "#F7F8FB"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M149.719 208.24L167.02 218.23V206.478L149.719 196.488V208.24Z",
    fill: "#F7F8FB"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M167.017 224.128L124.664 199.675V193.777L167.017 218.23V224.128Z",
    fill: "#5C93F8"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M313.281 302.677L330.585 312.667V300.917L313.281 290.926V302.677Z",
    fill: "#F7F8FB"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M273.086 279.47L278.349 282.51V270.757L273.086 267.719V279.47Z",
    fill: "#F7F8FB"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M265.125 274.875L270.388 277.915V266.163L265.125 263.125V274.875Z",
    fill: "#F7F8FB"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M257.164 270.278L262.427 273.317V261.566L257.164 258.527V270.278Z",
    fill: "#F7F8FB"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M249.203 265.681L254.466 268.721V256.968L249.203 253.93V265.681Z",
    fill: "#F7F8FB"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M305.537 298.206L288.234 288.218V276.465L305.537 286.455V298.206Z",
    fill: "#F7F8FB"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M288.234 294.111L330.588 318.564V312.666L288.234 288.215V294.111Z",
    fill: "#5C93F8"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M238.695 259.617L216.547 246.83V235.078L238.695 247.866V259.617Z",
    fill: "#F7F8FB"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M141.967 236.042L124.664 226.052V214.301L141.967 224.291V236.042Z",
    fill: "#F7F8FB"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M182.162 259.248L176.898 256.209V244.457L182.162 247.495V259.248Z",
    fill: "#F7F8FB"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M190.122 263.846L184.859 260.807V249.055L190.122 252.094V263.846Z",
    fill: "#F7F8FB"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M198.084 268.443L192.82 265.405V253.652L198.084 256.692V268.443Z",
    fill: "#F7F8FB"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M206.046 273.037L200.781 269.998V258.246L206.046 261.285V273.037Z",
    fill: "#F7F8FB"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M149.719 240.514L167.02 250.503V238.752L149.719 228.762V240.514Z",
    fill: "#F7F8FB"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M167.017 256.401L124.664 231.949V226.051L167.017 250.503V256.401Z",
    fill: "#5C93F8"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M313.281 334.951L330.585 344.941V333.189L313.281 323.199V334.951Z",
    fill: "#F7F8FB"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M273.086 311.745L278.349 314.783V303.032L273.086 299.992V311.745Z",
    fill: "#F7F8FB"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M265.125 307.15L270.388 310.188V298.437L265.125 295.398V307.15Z",
    fill: "#F7F8FB"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M257.164 302.552L262.427 305.591V293.839L257.164 290.801V302.552Z",
    fill: "#F7F8FB"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M249.203 297.955L254.466 300.993V289.243L249.203 286.203V297.955Z",
    fill: "#F7F8FB"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M305.537 330.48L288.234 320.49V308.738L305.537 318.729V330.48Z",
    fill: "#F7F8FB"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M288.234 326.387L330.588 350.84V344.942L288.234 320.488V326.387Z",
    fill: "#5C93F8"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M238.695 291.89L216.547 279.103V267.352L238.695 280.138V291.89Z",
    fill: "#F7F8FB"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M141.967 268.316L124.664 258.327V246.574L141.967 256.564V268.316Z",
    fill: "#F7F8FB"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M182.162 291.521L176.898 288.482V276.73L182.162 279.769V291.521Z",
    fill: "#F7F8FB"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M190.122 296.118L184.859 293.08V281.328L190.122 284.366V296.118Z",
    fill: "#F7F8FB"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M198.084 300.716L192.82 297.676V285.926L198.084 288.964V300.716Z",
    fill: "#F7F8FB"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M206.046 305.313L200.781 302.274V290.523L206.046 293.562V305.313Z",
    fill: "#F7F8FB"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M149.719 272.789L167.02 282.781V271.029L149.719 261.039V272.789Z",
    fill: "#F7F8FB"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M167.017 288.677L124.664 264.225V258.328L167.017 282.781V288.677Z",
    fill: "#5C93F8"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M313.281 367.224L330.585 377.214V365.463L313.281 355.473V367.224Z",
    fill: "#F7F8FB"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M273.086 344.018L278.349 347.057V335.305L273.086 332.266V344.018Z",
    fill: "#F7F8FB"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M265.125 339.425L270.388 342.464V330.711L265.125 327.672V339.425Z",
    fill: "#F7F8FB"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M257.164 334.826L262.427 337.865V326.114L257.164 323.074V334.826Z",
    fill: "#F7F8FB"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M249.203 330.228L254.466 333.268V321.516L249.203 318.477V330.228Z",
    fill: "#F7F8FB"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M305.537 362.753L288.234 352.762V341.012L305.537 351.002V362.753Z",
    fill: "#F7F8FB"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M288.234 358.659L330.588 383.113V377.215L288.234 352.762V358.659Z",
    fill: "#5C93F8"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M238.695 324.163L216.547 311.377V299.625L238.695 312.411V324.163Z",
    fill: "#F7F8FB"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M141.967 300.589L124.664 290.599V278.848L141.967 288.838V300.589Z",
    fill: "#F7F8FB"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M182.162 323.795L176.898 320.757V309.004L182.162 312.043V323.795Z",
    fill: "#F7F8FB"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M190.122 328.391L184.859 325.353V313.602L190.122 316.64V328.391Z",
    fill: "#F7F8FB"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M198.084 332.989L192.82 329.951V318.199L198.084 321.238V332.989Z",
    fill: "#F7F8FB"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M206.046 337.584L200.781 334.546V322.793L206.046 325.832V337.584Z",
    fill: "#F7F8FB"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M149.719 305.06L167.02 315.05V303.297L149.719 293.309V305.06Z",
    fill: "#F7F8FB"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M167.017 320.949L124.664 296.495V290.598L167.017 315.051V320.949Z",
    fill: "#5C93F8"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M313.281 399.497L330.585 409.487V397.735L313.281 387.746V399.497Z",
    fill: "#F7F8FB"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M273.086 376.29L278.349 379.329V367.577L273.086 364.539V376.29Z",
    fill: "#F7F8FB"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M265.125 371.697L270.388 374.735V362.984L265.125 359.945V371.697Z",
    fill: "#F7F8FB"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M257.164 367.099L262.427 370.139V358.386L257.164 355.348V367.099Z",
    fill: "#F7F8FB"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M249.203 362.5L254.466 365.54V353.788L249.203 350.75V362.5Z",
    fill: "#F7F8FB"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M305.537 395.027L288.234 385.037V373.285L305.537 383.274V395.027Z",
    fill: "#F7F8FB"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M288.234 390.933L330.588 415.384V409.488L288.234 385.035V390.933Z",
    fill: "#5C93F8"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M238.695 356.436L216.547 343.65V331.898L238.695 344.686V356.436Z",
    fill: "#F7F8FB"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M141.967 332.863L124.664 322.873V311.121L141.967 321.11V332.863Z",
    fill: "#F7F8FB"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M182.162 356.064L176.898 353.025V341.273L182.162 344.313V356.064Z",
    fill: "#F7F8FB"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M190.122 360.662L184.859 357.623V345.871L190.122 348.91V360.662Z",
    fill: "#F7F8FB"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M198.084 365.26L192.82 362.22V350.469L198.084 353.507V365.26Z",
    fill: "#F7F8FB"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M206.046 369.853L200.781 366.815V355.062L206.046 358.102V369.853Z",
    fill: "#F7F8FB"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M149.719 337.334L167.02 347.322V335.572L149.719 325.582V337.334Z",
    fill: "#F7F8FB"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M167.017 353.221L124.664 328.768V322.871L167.017 347.322V353.221Z",
    fill: "#5C93F8"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M313.281 431.772L330.585 441.761V430.01L313.281 420.02V431.772Z",
    fill: "#F7F8FB"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M273.086 408.564L278.349 411.602V399.852L273.086 396.812V408.564Z",
    fill: "#F7F8FB"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M265.125 403.97L270.388 407.009V395.258L265.125 392.219V403.97Z",
    fill: "#F7F8FB"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M257.164 399.374L262.427 402.412V390.66L257.164 387.621V399.374Z",
    fill: "#F7F8FB"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M249.203 394.775L254.466 397.813V386.062L249.203 383.023V394.775Z",
    fill: "#F7F8FB"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M305.537 427.3L288.234 417.31V405.559L305.537 415.549V427.3Z",
    fill: "#F7F8FB"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M288.234 423.206L330.588 447.659V441.761L288.234 417.309V423.206Z",
    fill: "#5C93F8"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M238.695 388.711L216.547 375.923V364.172L238.695 376.958V388.711Z",
    fill: "#F7F8FB"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M338.211 218.65L117.039 90.957V100.719L338.211 228.412V218.65Z",
    fill: "#5C93F8"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M338.211 514.193L117.039 386.5V341.098L338.211 468.791V514.193Z",
    fill: "#5C93F8"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M192.823 430.252L176.898 421.058V387.633L192.823 396.828V430.252Z",
    fill: "#B6CEFB"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M278.355 479.635L262.43 470.44V437.016L278.355 446.209V479.635Z",
    fill: "#B6CEFB"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M338.211 468.792L452.659 402.716V162.336L338.211 228.412V468.792Z",
    fill: "#5C93F8"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M338.211 218.65L452.659 152.574V162.336L338.211 228.412V218.65Z",
    fill: "#003EB3"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M338.211 514.193L452.659 448.117V402.715L338.211 468.791V514.193Z",
    fill: "#003EB3"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M391.561 221.724L374.258 231.714V219.962L391.561 209.973V221.724Z",
    fill: "#C2CDDD"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M374.258 237.608L416.612 213.156V207.258L374.258 231.711V237.608Z",
    fill: "#003EB3"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M399.305 217.249L416.609 207.259V195.508L399.305 205.498V217.249Z",
    fill: "#C2CDDD"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M391.561 253.998L374.258 263.987V252.235L391.561 242.246V253.998Z",
    fill: "#C2CDDD"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M374.258 269.885L416.612 245.433V239.535L374.258 263.988V269.885Z",
    fill: "#003EB3"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M399.305 249.526L416.609 239.536V227.785L399.305 237.774V249.526Z",
    fill: "#C2CDDD"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M391.561 286.271L374.258 296.261V284.51L391.561 274.52V286.271Z",
    fill: "#C2CDDD"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M374.258 302.158L416.612 277.705V271.809L374.258 296.261V302.158Z",
    fill: "#003EB3"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M399.305 281.796L416.609 271.807V260.055L399.305 270.045V281.796Z",
    fill: "#C2CDDD"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M391.561 318.545L374.258 328.535V316.783L391.561 306.793V318.545Z",
    fill: "#C2CDDD"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M374.258 334.431L416.612 309.98V304.082L374.258 328.535V334.431Z",
    fill: "#003EB3"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M399.305 314.07L416.609 304.081V292.328L399.305 302.319V314.07Z",
    fill: "#C2CDDD"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M391.561 350.814L374.258 360.804V349.052L391.561 339.062V350.814Z",
    fill: "#C2CDDD"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M374.258 366.702L416.612 342.248V336.352L374.258 360.804V366.702Z",
    fill: "#003EB3"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M399.305 346.343L416.609 336.353V324.602L399.305 334.592V346.343Z",
    fill: "#C2CDDD"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M391.561 383.087L374.258 393.078V381.326L391.561 371.336V383.087Z",
    fill: "#C2CDDD"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M374.258 398.975L416.612 374.523V368.625L374.258 393.078V398.975Z",
    fill: "#003EB3"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M399.305 378.617L416.609 368.627V356.875L399.305 366.864V378.617Z",
    fill: "#C2CDDD"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M391.561 415.358L374.258 425.347V413.595L391.561 403.605V415.358Z",
    fill: "#C2CDDD"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M374.258 431.245L416.612 406.792V400.895L374.258 425.347V431.245Z",
    fill: "#003EB3"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M399.305 410.886L416.609 400.896V389.145L399.305 399.135V410.886Z",
    fill: "#C2CDDD"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M327.582 188.908L167.594 96.5381V50.9492L327.582 143.318V188.908Z",
    fill: "#5C93F8"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M208.628 110.596L196.117 103.372V78.7539L208.628 85.9767V110.596Z",
    fill: "#F7F8FB"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M238.769 127.997L226.258 120.774V96.1562L238.769 103.38V127.997Z",
    fill: "#F7F8FB"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M268.917 145.399L256.406 138.176V113.559L268.917 120.781V145.399Z",
    fill: "#F7F8FB"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M299.059 162.802L286.547 155.579V130.961L299.059 138.185V162.802Z",
    fill: "#F7F8FB"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M402.058 145.91L327.586 188.906V143.316L402.058 100.32V145.91Z",
    fill: "#002466"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M362.356 159.196L349.844 166.42V141.802L362.356 134.578V159.196Z",
    fill: "#C2CDDD"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M379.801 149.123L367.289 156.346V131.728L379.801 124.504V149.123Z",
    fill: "#C2CDDD"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M327.551 143.365L167.562 50.9949L242.033 8L402.021 100.369L327.551 143.365Z",
    fill: "#003EB3"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M301.514 100.309L239.047 64.2425V46.4414L301.514 82.5082V100.309Z",
    fill: "#5C93F8"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M330.594 83.5199L301.516 100.309V82.5075L330.594 65.7188V83.5199Z",
    fill: "#002466"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M301.499 82.5252L239.031 46.4595L268.108 29.6719L330.576 65.7376L301.499 82.5252Z",
    fill: "#003EB3"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedio);
export default __webpack_public_path__ + "static/media/medio.841131c288de81cfd2df4e6c3be91cf9.svg";
export { ForwardRef as ReactComponent };